import { call } from 'redux-saga/effects';

export const blocker = () => call(() => new Promise(() => ({})));
